var map = {
	"./Abstract-creation-copy-1005x1024.webp": 5437,
	"./Atlas-lifestyle-UI-1024x683.webp": 1313,
	"./BL-gel-preview-1024x717.webp": 3374,
	"./CBRPNK_CHICK-724x1024.webp": 5911,
	"./Confused-Sketch.webp": 5271,
	"./Cote-de-Veau-1024x1024.webp": 416,
	"./Days-of-the-week-Saturday-copy-1024x1024.webp": 4585,
	"./Days-of-the-week-Sunday-1024x1024.webp": 5646,
	"./Days-of-the-week-Tuesday-v2-copy-1024x1024.webp": 6147,
	"./Days-of-the-week-Wednesday-copy-1024x1024.webp": 462,
	"./Days-of-the-week-friday-v2-1024x1024.webp": 8786,
	"./FlicksBuddy-1024x922.webp": 1079,
	"./Golden-Sushi-Landing-page-1024x576.webp": 5279,
	"./Kaaouis-1024x1024.webp": 79,
	"./Konoha-skull-794x1024.webp": 4015,
	"./Monday-Days-of-the-week-1024x1024.webp": 5958,
	"./Nikkei-723x1024.webp": 2204,
	"./PXL-2-mockup-910x1024.webp": 4641,
	"./PayEZ-App-preview-1024x684.webp": 6556,
	"./Poly-design-App-mobile--931x1024.webp": 390,
	"./RS-Racing-Website-Concept-439x1024.webp": 9814,
	"./RS-banner-v2-1024x456.webp": 1908,
	"./Relax-by-wikiweed-1024x341.webp": 6490,
	"./Rock-character-857x1024.webp": 4538,
	"./Skin-782x1024.webp": 6028,
	"./Standing-angry-540x1024.webp": 4687,
	"./The-magic-ba-sttof-794x1024.webp": 3297,
	"./Travinglo-showcase-1024x768.webp": 7953,
	"./Ui-1-793x1024.webp": 8093,
	"./Unipoly-UI-1024x566.webp": 525,
	"./ach-had-takos-1024x614.webp": 7711,
	"./achraf-photostudio-sign-1024x683.webp": 3797,
	"./bad-Character-1024x788.webp": 2546,
	"./crop-logo-1024x1024.webp": 827,
	"./datavidual-1024x819.webp": 332,
	"./delivery-guy-with-sign.webp": 8,
	"./halloweed-test-3-1024x1024.webp": 5136,
	"./intense-masculine-819x1024.webp": 8387,
	"./liver-1024x1024.webp": 1058,
	"./photomanip-bo-zomanja-1024x1024.webp": 1751,
	"./roy-stay-tuned-1024x576.webp": 688,
	"./surroundings1-1024x576.webp": 2857,
	"./wikiWeed-20_-reduction-1024x341.webp": 6798,
	"./wikiweed-pineapple-express-1024x1024.webp": 960
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7500;